<app-base-container></app-base-container>
<link id="customCss" (load)="onCssSuccess()" (error)="onCssError()" rel="stylesheet">
<div id="overlay" class="overlay"></div>
